/**
 * A function that triggers when wanting to expand the expand buttons
 */
const toggleExpandButton = (buttonEl) => {
	const isExpanded = buttonEl.hasClass("expanded");
	const parentExpandButtons = buttonEl
		.parents(".main-menu > .menu-item")
		.children(".expand-submenu-button");

	//* Close the sub-menu
	if (isExpanded) {
		buttonEl.removeClass("expanded");
		buttonEl.attr("aria-expanded", "false");
		buttonEl.parent().children("a").attr("aria-expanded", "false");
		buttonEl.parent().css("z-index", 0);
		// buttonEl.siblings(".sub-menu").css("pointer-events", "none");
		parentExpandButtons.removeClass("expanded");
		parentExpandButtons.attr("aria-expanded", "false");
	}
	//* Open the sub-menu
	else {
		//* Close all other sub-menus
		const siblingButtons = buttonEl
			.parent()
			.siblings()
			.children(".expand-submenu-button");
		siblingButtons.removeClass("expanded");
		siblingButtons.attr("aria-expanded", "false");

		//* Open the sub-menu
		buttonEl.addClass("expanded");
		buttonEl.attr("aria-expanded", "true");
		buttonEl.parent().children("a").attr("aria-expanded", "false");
		buttonEl.parent().css("z-index", 100);
		parentExpandButtons.addClass("expanded");
		parentExpandButtons.attr("aria-expanded", "true");
	}
};

/**
 * A function that triggers when wanting to add pointer events to the sub-menu, which is a sibling of an expand button
 * @param {object} buttonEl The expand button element
 */
const addPointerEventsToSubMenu = (buttonEl) => {
	const submenuEl = buttonEl.siblings(".sub-menu");

	// const hasPointerEvents = submenuEl.css("pointer-events") === "all";

	// console.log(
	// 	"🚀 ~ file: mainMenuTabber.js:56 ~ addPointerEventsToSubMenu ~ submenuEl:",
	// 	submenuEl
	// );

	//* If the sub-menu is expanded, add pointer events after 100ms timeout
	if (!hasPointerEvents) {
		setTimeout(() => {
			// submenuEl.css("pointer-events", "all");
		}, 20);
	}
	//* If the sub-menu is not expanded, remove pointer events
	else {
		// submenuEl.css("pointer-events", "none");
	}
};

var mmt,
	MainMenuTabbing = {
		settings: {},

		init: function () {
			mmt = this.settings;
			this.bindUIActions();
			// console.log('MainMenuTabbing functionality loaded!');
		},

		bindUIActions: function () {
			// On window load or resize
			$(window).on("load resize", function () {
				// Remove any injected styles into sub-menu elements
				$("header .main-menu > .menu-item > .sub-menu").attr(
					"style",
					""
				);

				if ($(window).width() >= 1201) {
					$(".expand-submenu-button").removeClass("expanded").blur();
				}
			});

			$(window).on("load", function () {
				// If a menu item has children (or a sub-menu), inject an "expansion arrow" for accessibility after the link in the menu item's link.
				$("header .menu-item-has-children > a").each(function () {
					var el = $(this);
					var menuText = el.text();
					var menuId =
						"submenu-" +
						menuText
							.replace(/[^a-z0-9\s-]/gi, "")
							.trim()
							.replace(/\s+/g, "-")
							.toLowerCase() +
						"-" +
						Math.floor(Math.random() * 1000);
					el.next().attr("id", menuId);
					el.attr("aria-haspopup", "true");
					el.attr("aria-expanded", "false");
					el.after(
						'<button class="expand-submenu-button" aria-label="' +
							menuText +
							' Menu" aria-controls="' +
							menuId +
							'" aria-expanded="false"><i class="far fa-chevron-down"></i></button>'
					);
				});

				// // on hover of the menu item, add aria-expanded true to el
				$(".mobile-main-menu > .menu-item").on(
					"mouseenter",
					function () {
						const el = $(this).children(".expand-submenu-button");
						addPointerEventsToSubMenu(el);
					}
				);

				$(".mobile-main-menu > .menu-item").on(
					"mouseleave",
					function () {
						const el = $(this).children(".expand-submenu-button");

						addPointerEventsToSubMenu(el);
					}
				);

				$(
					".mobile-main-menu > .menu-item-has-children > .expand-arrow"
				).on("click", function (e) {
					const el = $(this).siblings("a");
					e.preventDefault();

					const isExpanded = el.attr("aria-expanded") === "true";

					//* Close all other sub-menus
					el.parent()
						.siblings()
						.children("a")
						.attr("aria-expanded", "false");

					if (isExpanded) {
						el.attr("aria-expanded", "false");
					} else {
						el.attr("aria-expanded", "true");
					}
				});

				// //* On hover of the mobile menu menu item, add pointer events to the sub-menu
				// $(document).on(
				// 	"mouseenter",
				// 	"mobile-main-menu > .menu-item-has-children",
				// 	function () {
				// 		const buttonEl = $(this).children(
				// 			".expand-submenu-button"
				// 		);
				// 		addPointerEventsToSubMenu(buttonEl);
				// 	}
				// );

				// //* On un-hover of the mobile menu menu item, remove pointer events from the sub-menu
				// $(document).on(
				// 	"mouseleave",
				// 	"mobile-main-menu > .menu-item-has-children",
				// 	function () {
				// 		const buttonEl = $(this).children(
				// 			".expand-submenu-button"
				// 		);
				// 		addPointerEventsToSubMenu(buttonEl);
				// 	}
				// );

				// $("mobile-main-menu > .menu-item-has-children").hover(() => {
				// 	const buttonEl = $(this).children(".expand-submenu-button");
				// 	addPointerEventsToSubMenu(buttonEl);
				// });
			});

			// When interacted with (clicked)
			$(document).on("click", ".expand-submenu-button", function (event) {
				var buttonEl = $(this);
				// console.log("click, .expand-submenu-button", event);
				event.preventDefault();
				toggleExpandButton(buttonEl);
			});

			// When interacted with (key pressed)
			$(document).on(
				"keydown",
				".expand-submenu-button.expanded",
				function (event) {
					// console.log(
					// 	"keydown, .expand-submenu-button.expanded",
					// 	event
					// );
					// If 'tab key'
					if (event.which === 9) {
						// If 'shift key'
						if (event.shiftKey) {
							const expandButtons = $(this);
							// .parents(".main-menu")
							// .find(".expand-submenu-button.expanded");

							expandButtons.removeClass("expanded");
							expandButtons.attr("aria-expanded", "false");
							expandButtons
								.parent()
								.children("a")
								.attr("aria-expanded", "false");
						}
					}
				}
			);

			// When the last menu item is focused and the tab key is pressed, it should close the menu.
			$(document).on(
				"keydown",
				".sub-menu > .menu-item:last-child",

				function (event) {
					// If there is a remaining expand-submenu-button to tab too, then do nothing.
					// console.log(
					// 	"keydown, .sub-menu .menu-item:last-child",
					// 	event,
					// );
					const isOnDepth0 =
						$(event.target).parents(".sub-menu.depth-0").length > 0;
					const isOnDepth1 =
						$(event.target).parents(".sub-menu.depth-1").length > 0;

					if (isOnDepth0 && !isOnDepth1) {
						const isLastFocusableElement = $(event.target).is(
							":last-child"
						);
						if (!isLastFocusableElement) {
							return;
						}
					}

					if (isOnDepth1) {
						// console.log("depth1");
						const isLastFocusableElement = $(event.target)
							.parent()
							.is(":last-child");
						if (!isLastFocusableElement) {
							// console.log("not last");
							return;
						}
					}

					// if (
					// 	$(event.target).siblings(".expand-submenu-button")
					// 		.length > 0
					// ) {
					// 	return;
					// }
					// if (
					// 	$(event.target).is(
					// 		"button.expand-submenu-button.expanded"
					// 	)
					// ) {
					// 	console.log("this");
					// 	return;
					// }
					// if (
					// 	$(event.target)
					// 		.parent()
					// 		.siblings("button.expand-submenu-button.expanded")
					// 		.length > 0 &&
					// 	!$(event.target).is("*:last-child")
					// ) {
					// 	return;
					// }
					// if (
					// 	$(event.currentTarget).is("*:not(:last-child)") &&
					// 	!$(event.target).localName == "a"
					// ) {
					// 	return;
					// }

					// If 'tab key'
					if (event.which === 9) {
						// If 'shift key'
						if (event.shiftKey) {
							// Do nothing.
						} else {
							// Prevent the default behavior.
							event.preventDefault();
							// // Find the parents of '.sub-menu .menu-item:last-child' and add or remove the expanded class.
							// //$(this).parents(".menu-item").next().focus();
							const expandButtons =
								MainMenuTabbing.getParentExpandButton(this);
							// //$(event.target).parent().attr("tabIndex", "-1");
							expandButtons.toggleClass("expanded");
							expandButtons.attr("aria-expanded", "false");
							expandButtons
								.parent()
								.children("a")
								.attr("aria-expanded", "false");
						}
					}
				}
			);

			// Close Submenu when last expand button is focused and tab key is pressed.
			$(document).on(
				"keydown",
				".sub-menu .menu-item:last-child .expand-submenu-button:not(.expanded)",
				function (event) {
					// console.log(
					// 	"keydown, .sub-menu .menu-item:last-child .expand-submenu-button:not(.expanded)",
					// 	event
					// );
					// If 'tab key'
					if (event.which === 9) {
						// If 'shift key'
						if (event.shiftKey) {
							// Do nothing.
						} else {
							// Prevent the default behavior.
							event.preventDefault();
							// Find the parents of '.sub-menu .menu-item:last-child' and add or remove the expanded class.
							//$(this).parents(".menu-item").next().focus();

							const expandButtons =
								MainMenuTabbing.getAllParentExpandButtons(this);
							//$(event.target).parent().attr("tabIndex", "-1");
							expandButtons.toggleClass("expanded");
							expandButtons.attr("aria-expanded", "false");
							expandButtons
								.parent()
								.children("a")
								.attr("aria-expanded", "false");
						}
					}
				}
			);

			// When the first menu item is focused and the shift and tab keys are pressed together, it should close the menu.
			$(document).on(
				"keydown",
				".sub-menu .menu-item:first-child",
				function (event) {
					// console.log(
					// 	"keydown, .sub-menu .menu-item:first-child",
					// 	event
					// );
					// If 'tab key'
					if (event.which === 9) {
						// If 'shift key'
						if (event.shiftKey) {
							// console.log("shift?");
							// Prevent the default behavior.
							event.preventDefault();
							// Find the parents of '.sub-menu .menu-item:last-child' and add or remove the expanded class.

							//$(this).parents(".main-menu").focus();
							const expandButtons =
								MainMenuTabbing.getParentExpandButton(
									event.currentTarget
								);

							//$(event.target).attr("tab-index", "-1");
							//$(event.target).attr("tab-index", "");
							expandButtons.toggleClass("expanded");
							expandButtons.attr("aria-expanded", "false");
							expandButtons
								.parent()
								.children("a")
								.attr("aria-expanded", "false");
						}
					}
				}
			);
		},
		getAllParentExpandButtons: function (element) {
			return $(element)
				.parents(".main-menu > .menu-item")
				.children(".expand-submenu-button");
		},
		getParentExpandButton: function (element) {
			return $(element).parent().siblings(".expand-submenu-button");
		},
	};

module.exports = MainMenuTabbing;
